import { PublicClientApplication, type Configuration } from '@azure/msal-browser';

const clientId = import.meta.env.VITE_AAD_CLIENT_ID ?? '';
const tenantId = import.meta.env.VITE_AAD_TENANT_ID ?? '';
const apiScope = import.meta.env.VITE_API_SCOPE ?? '';

/**
 * Set VITE_AUTH_DISABLED=true to run the SPA against a locally hosted API that also has
 * Auth:DisableAuthentication turned on. Never set this for a deployed environment.
 */
export const authDisabled = import.meta.env.VITE_AUTH_DISABLED === 'true';

export const apiBaseUrl = (import.meta.env.VITE_API_BASE_URL ?? '').replace(/\/$/, '');

const configuration: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    // Session storage keeps a shared club laptop from staying signed in indefinitely.
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    // The silent-renewal iframe has to load Entra ID and come back. The 6s default is tight on a
    // slow connection, and timing out there surfaces as monitor_window_timeout.
    iframeHashTimeout: 12000,
    loadFrameTimeout: 12000,
  },
};

export const msalInstance = new PublicClientApplication(configuration);

/** Scopes requested when calling the poster API. */
export const apiRequest = { scopes: apiScope ? [apiScope] : [] };

/** Scopes requested at sign-in. */
export const loginRequest = { scopes: ['openid', 'profile', ...apiRequest.scopes] };
